import { render, staticRenderFns } from "./EditProfessionalInfoDialog.vue?vue&type=template&id=83e8243c&scoped=true"
import script from "./EditProfessionalInfoDialog.vue?vue&type=script&lang=js"
export * from "./EditProfessionalInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./EditProfessionalInfoDialog.vue?vue&type=style&index=0&id=83e8243c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e8243c",
  null
  
)

export default component.exports